import { render } from "./InstallPwaButton.vue?vue&type=template&id=5ccade0a&scoped=true"
import script from "./InstallPwaButton.vue?vue&type=script&lang=js"
export * from "./InstallPwaButton.vue?vue&type=script&lang=js"

import "./InstallPwaButton.vue?vue&type=style&index=0&id=5ccade0a&scoped=true&lang=css"

import exportComponent from "/home/dyam/Documentos/ZEPPELIN/mi-stock-zeppelin-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ccade0a"]])

export default __exports__